/* eslint-disable no-nested-ternary */
import { Box, Link, Typography } from '@mui/material';
import { GalleryIcon } from 'assets/icons';
import pdfDocument from 'assets/images/pdf-document.png';
import compressFile from 'assets/images/compress-file.png';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { FileType } from 'utils/file-uploader';
import VideoPreviewPlayer from '../video-preview-player';

interface ContentMediaViewProps {
  fileName: string | undefined;
  mediaType: string;
  url?: string;
  thumbnail?: string | undefined;
}

const ContentMediaView = ({
  fileName, mediaType, url, thumbnail,
}: ContentMediaViewProps) => {
  const mediaItem = mediaType === FileType.IMAGE ? (
    <Box
      component="img"
      src={url}
      sx={{
        width: 'auto',
        maxWidth: '100%',
        height: 'auto',
        objectFit: 'cover',
      }}
    />
  ) : mediaType === FileType.VIDEO ? (
    <Box
      sx={{
        backgroundColor: '#F2F2F2',
        height: '100%',
        minWidth: '250px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <VideoPreviewPlayer url={url || ''} light={(thumbnail && thumbnail !== '') ? thumbnail : false} />
    </Box>
  ) : mediaType === FileType.DOCUMENT ? (
    <Box
      sx={{
        backgroundColor: '#F2F2F2',
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Box
        component="img"
        sx={{
          width: '65px',
          height: 'auto',
          objectFit: 'cover',
          margin: '20px',
        }}
        src={pdfDocument}
      />
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2, textAlign: 'center' }}>
        {fileName}
      </Typography>
    </Box>
  ) : mediaType === FileType.COMPRESSED_FILE ? (
    <Box
      sx={{
        backgroundColor: '#F2F2F2',
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Box
        component="img"
        sx={{
          width: '65px',
          height: 'auto',
          objectFit: 'cover',
          margin: '20px',
        }}
        src={compressFile}
      />
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2, textAlign: 'center' }}>
        {fileName}
      </Typography>
    </Box>
  ) : (
    <Box
      sx={{
        backgroundColor: '#F2F2F2',
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <AttachFileIcon />
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2, textAlign: 'center' }}>
        {fileName}
      </Typography>
    </Box>
  );

  return (
    <div
      data-testid="ContentMediaView"
      style={{
        height: '100%', width: '100%', maxWidth: '100%',
      }}
    >
      {url === '' && (
        <Box
          sx={{
            backgroundColor: '#FAFAFC',
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '40px',
          }}
        >
          <GalleryIcon fontSize="large" />
        </Box>
      )}
      {url !== '' && mediaType === 'video' && mediaItem}
      {url !== '' && mediaType !== 'video' && (
        <Link href={url} underline="none" target="_blank" sx={{ borderRadius: '6px', overflow: 'hidden', display: 'flex' }}>
          {mediaItem}
        </Link>
      )}
    </div>
  );
};

ContentMediaView.defaultProps = {
  url: '',
  thumbnail: undefined,
};

export default ContentMediaView;
